/**
 * Blank Layout
 * Minimal layout: only router outlet with theme support
 * Used for authentication flows, error pages, or flows without navigation
 */

export { BlankComponent } from './blank.component';
